import React from 'react'
import clsx from 'clsx';
import { FirebaseContext } from "../../firebase";
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import Listas from './Listas';
import { Button, Avatar } from '@material-ui/core';
import {withRouter} from 'react-router-dom';
import logo from '../../img/LogoPunto5.png';
import punto5Avatar from '../../img/Punto5_Avatar.png';
import UsuarioContext from '../contex/UsuarioContext';

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  hide: {
    display: 'none',
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    background: '#29588F',
  },
  drawerOpen: {
    width: drawerWidth,
    background: '#29588F',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    background: '#29588F',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9) + 1,
    },
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  title: {
    flexGrow: 1
},
avatar: {
  margin: 10,
  width: 40,
  height: 40

}
}));



const HeaderPrivado = (props) => {
    const { user, firebase } = React.useContext(FirebaseContext);
    const usuarioContextLocal = React.useContext(UsuarioContext);
    const { setObjUsuario, objUsuario } = usuarioContextLocal;

    const classes = useStyles();
    const theme = useTheme();
    const [open, setOpen] = React.useState(false);
    const handleDrawerOpen = () => {
        setOpen(true);
      };
    
      const handleDrawerClose = () => {
        setOpen(false);
      };

      const logout = () => {
        const newObjUsuario = {...objUsuario}
        newObjUsuario.rol = 0
        setObjUsuario(newObjUsuario);
        props.history.push('/')
        firebase.logout()
      }

    return (
        <div>
                  <AppBar
        position="fixed"
        className={clsx(classes.appBar, {
          [classes.appBarShift]: open,
        })}
      >
        <Toolbar>
          
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            className={clsx(classes.menuButton, {
              [classes.hide]: open,
            })}
          >
            <MenuIcon />
          </IconButton>
          <img src={logo} alt="Logo punto 5"/>
          <Typography variant="h6" className={classes.title}>
          ¡Ahora ya no tienes límites!
          </Typography>

       
                         <Button
                            variant="text"
                            color="inherit"
                        >
                            {user.displayName}
                        </Button>
                        <Avatar className={classes.avatar} src={user.photoURL || punto5Avatar} />
                        <Typography variant="h6" >|</Typography>                    
                        <Button
                            variant="text"
                            color="inherit"
                            onClick={() => logout()}
                        >
                            CERRAR
                        </Button>



        </Toolbar>
      </AppBar>
      <Drawer
        variant="permanent"
        className={clsx(classes.drawer, {
          [classes.drawerOpen]: open,
          [classes.drawerClose]: !open,
        })}
        classes={{
          paper: clsx({
            [classes.drawerOpen]: open,
            [classes.drawerClose]: !open,
          }),
        }}
      >
        <div className={classes.toolbar}>
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
          </IconButton>
        </div>
        <Divider />
 
        <Listas />
       
      </Drawer>
        </div>
    )
}

export default withRouter(HeaderPrivado)
